export const formatAddress = (mailingAddress) => {
    const { 'cipher.addressLine1': addressLine1, 'cipher.addressLine2': addressLine2 = '', 'cipher.city': city, 'cipher.state': state, 'cipher.zipCode': zipCode } = mailingAddress;
    return `${addressLine1}${addressLine2}\n${city}, ${state} ${zipCode}`;
};
//# sourceMappingURL=format.js.map